// using multiple ICONS.ADD_RAINBOW in our normal ICONS component creates id conflicts
// and the icon won't render properly
// so this is a separate component for the add rainbow icon

import randomString from '@/utils/random-string';

interface IconResendEmailGradientProps {
  /** id must be unique for each instance */
  id?: string;
  size?: number;
  from?: string;
  to?: string;
}

const IconResendEmailGradient = ({
  id: _id,
  size = 16,
  from = '#5AE4FF',
  to = '#A7FF7B',
}: IconResendEmailGradientProps) => {
  const id = _id || `icon-add-gradient-${randomString(6)}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M8.01206 8.05129C8.25964 8.05129 8.48911 7.93367 8.75481 7.66128L14.0084 2.33104C13.785 2.10817 13.3683 2.00293 12.7705 2.00293H3.04829C2.54104 2.00293 2.18476 2.10198 1.98549 2.30628L7.2693 7.66128C7.52896 7.92748 7.75843 8.05129 8.01206 8.05129Z"
        fill={`url(#paint0_${id})`}
      />
      <path
        d="M12.9517 12.6696H6.77193C6.91963 12.2522 7 11.803 7 11.335C7 10.2278 6.55017 9.22568 5.82331 8.50143L6.36351 7.95224L6.7681 8.36702C7.17872 8.77561 7.57124 8.96134 8.01206 8.96134C8.44684 8.96134 8.83935 8.77561 9.25602 8.36702L9.65457 7.95224L14.0084 12.3724C13.8092 12.5705 13.4589 12.6696 12.9517 12.6696Z"
        fill={`url(#paint1_${id})`}
      />
      <path
        d="M5.7536 7.34555L5.1476 7.95978C4.52718 7.56419 3.79036 7.33496 3 7.33496C2.40518 7.33496 1.84069 7.46479 1.33331 7.69767V3.91587C1.33331 3.48871 1.38162 3.19155 1.4722 3.01821L5.7536 7.34555Z"
        fill={`url(#paint2_${id})`}
      />
      <path
        d="M14.5217 11.6667C14.6183 11.4872 14.6666 11.1838 14.6666 10.7505V3.91587C14.6666 3.50109 14.6183 3.20394 14.5338 3.03679L10.2645 7.34555L14.5217 11.6667Z"
        fill={`url(#paint3_${id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.335C0 12.9732 1.35882 14.335 3 14.335C4.63824 14.335 6 12.9732 6 11.335C6 9.69378 4.64118 8.33496 3.00294 8.33496C1.36176 8.33496 0 9.69378 0 11.335ZM3.49118 12.4614C3.41471 12.5291 3.35294 12.5644 3.27647 12.5644C3.17059 12.5644 3.09118 12.4879 3.09118 12.382V11.7761H3.04412C2.43235 11.7761 2.04412 11.9291 1.77059 12.4467C1.71765 12.5467 1.64412 12.5644 1.57647 12.5644C1.49412 12.5644 1.41176 12.4908 1.41176 12.3555C1.41176 11.182 1.91176 10.4614 3.04412 10.4614H3.09118V9.85849C3.09118 9.75555 3.17059 9.66731 3.27941 9.66731C3.35588 9.66731 3.40588 9.70261 3.49118 9.77908L4.74118 10.9467C4.8 11.0026 4.82059 11.0614 4.82059 11.1173C4.82059 11.1703 4.8 11.2291 4.74118 11.285L3.49118 12.4614Z"
        fill={`url(#paint4_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="0"
          y1="8.16895"
          x2="14.6666"
          y2="8.16895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="0"
          y1="8.16895"
          x2="14.6666"
          y2="8.16895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="0"
          y1="8.16895"
          x2="14.6666"
          y2="8.16895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
        <linearGradient
          id={`paint3_${id}`}
          x1="0"
          y1="8.16895"
          x2="14.6666"
          y2="8.16895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
        <linearGradient
          id={`paint4_${id}`}
          x1="0"
          y1="8.16895"
          x2="14.6666"
          y2="8.16895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconResendEmailGradient;
